import React, { forwardRef } from 'react';
import { bool, string } from 'prop-types';
import clsx from 'clsx';
import { FormattedMessage } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';
//import { OwnListingLink } from'../../../../components';
import { VideoPlayer } from'../../../../components'; 
import config from '../../../../config'

import css from './SectionHowItWorks.module.css';

const HOW_IT_WORKS_CONSTANTS = {
  'home': {
    'id': 'how-tourly-works',
    'titleLineOne': "SectionHowItWorks.titleLineOne",
    'titleLineTwo': "SectionHowItWorks.titleLineTwo",
    'videoURL' : config.videoURL['tourist'],
    'part1Title': "SectionHowItWorks.part1Title",
    'part1Text': "SectionHowItWorks.part1Text",
    'part2Title': "SectionHowItWorks.part2Title",
    'part2Text': "SectionHowItWorks.part2Text",
    'part3Title': "SectionHowItWorks.part3Title",
    'part3Text': "SectionHowItWorks.part3Text"
  },
  'SA': {
    'id': 'how-it-works-SA',
    'titleLineOne': "SectionHowItWorks.SAtitleLineOne",
    'titleLineTwo': "SectionHowItWorks.SAtitleLineTwo",
    'videoURL' : config.videoURL['salesAssociate'],
    'part1Title': "SectionHowItWorks.SApart1Title",
    'part1Text': "SectionHowItWorks.SApart1Text",
    'part2Title': "SectionHowItWorks.SApart2Title",
    'part2Text': "SectionHowItWorks.SApart2Text",
    'part3Title': "SectionHowItWorks.SApart3Title",
    'part3Text': "SectionHowItWorks.SApart3Text"
  },
  'TO': {
    'id': 'how-it-works-TO',
    'titleLineOne': "SectionHowItWorks.TOtitleLineOne",
    'titleLineTwo': "SectionHowItWorks.TOtitleLineTwo",
    'videoURL' : config.videoURL['tourOperator'],
    'part1Title': "SectionHowItWorks.TOpart1Title",
    'part1Text': "SectionHowItWorks.TOpart1Text",
    'part2Title': "SectionHowItWorks.TOpart2Title",
    'part2Text': "SectionHowItWorks.TOpart2Text",
    'part3Title': "SectionHowItWorks.TOpart3Title",
    'part3Text': "SectionHowItWorks.TOpart3Text"
  }
}


const HowItWorksComponent = forwardRef((props, ref) => {
  const { classes, content:{
    id,
    titleLineOne,
    titleLineTwo,
    videoURL,
    part1Title,
    part1Text,
    part2Title,
    part2Text,
    part3Title,
    part3Text
  }={} } = props;

  return (
    <div className={classes} id={id} ref={ref}>
      <div className={css.title}>
        <FormattedMessage id={titleLineOne} />
        <br />
        <FormattedMessage id={titleLineTwo} />
      </div>
      <div className={css.howItWorksWrapper}>
        <VideoPlayer
          videoURL={videoURL}
          controls={true}
          videoWidth='100%'
        />
        <div className={css.steps}>
          <div className={css.step}>
            <h2 className={css.stepTitle}>
              <FormattedMessage id={part1Title} />
            </h2>
            <p>
              <FormattedMessage id={part1Text} />
            </p>
          </div>

          <div className={css.step}>
            <h2 className={css.stepTitle}>
              <FormattedMessage id={part2Title} />
            </h2>
            <p>
              <FormattedMessage id={part2Text} />
            </p>
          </div>

          <div className={css.step}>
            <h2 className={css.stepTitle}>
              <FormattedMessage id={part3Title} />
            </h2>
            <p>
              <FormattedMessage id={part3Text} />
            </p>
          </div>
        </div>
      </div>
      <div className={css.createListingLink}>
        {/* <OwnListingLink listing={currentUserListing} listingFetched={currentUserListingFetched}>
          <FormattedMessage id="SectionHowItWorks.createListingLink" />
        </OwnListingLink> */}
      </div>
    </div>
  );
});

const HowItWorksFactory = forwardRef((props, ref) => {
  const { pathname, classes } = props;

  switch (pathname) {
    case '/home':
      return <HowItWorksComponent content={HOW_IT_WORKS_CONSTANTS['home']} classes={classes} />;
    case '/tour-operators':
      return <HowItWorksComponent content={HOW_IT_WORKS_CONSTANTS['TO']} classes={classes} ref={ref} />;
    case '/affiliates':
      return <HowItWorksComponent content={HOW_IT_WORKS_CONSTANTS['SA']} classes={classes} ref={ref} />;
    default:
      break;
  }
});

const SectionHowItWorks = forwardRef((props, ref) => {
  const { rootClassName, className, location } = props;

  const pathname = location.pathname

  const classes = clsx(rootClassName || css.root, className);
  return (
    <HowItWorksFactory
      pathname={pathname}
      classes={classes}
      ref={ref}
    />
  );
});

SectionHowItWorks.defaultProps = {
  rootClassName: null,
  className: null,
  currentUserListing: null,
  currentUserListingFetched: false,
};

SectionHowItWorks.propTypes = {
  rootClassName: string,
  className: string,
  currentUserListing: propTypes.ownListing,
  currentUserListingFetched: bool,
};

export default SectionHowItWorks;
